import React from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const Footer = () => {
  const { footer } = content;

  const socialIcons = [
    {
      name: footer.social[0],
      path: "M22 12.07C22 6.48 17.52 2 12 2S2 6.48 2 12.07c0 5.02 3.66 9.18 8.44 9.93v-7.03H7.9v-2.9h2.54V9.79c0-2.5 1.49-3.89 3.78-3.89 1.1 0 2.25.2 2.25.2v2.48h-1.27c-1.25 0-1.64.78-1.64 1.58v1.9h2.8l-.45 2.9h-2.35v7.03C18.34 21.25 22 17.08 22 12.07z",
    },
    {
      name: footer.social[1],
      path: "M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.44-2.13 2.93v5.68H9.42V9h3.41v1.56h.05c.48-.91 1.66-1.87 3.41-1.87 3.65 0 4.32 2.4 4.32 5.52v6.31zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM6.89 20.45H3.79V9h3.1v11.45z",
    },
    {
      name: footer.social[2],
      path: "M23.954 4.569c-.885.392-1.83.656-2.825.775a4.932 4.932 0 0 0 2.163-2.724c-.951.555-2.005.959-3.127 1.184a4.916 4.916 0 0 0-8.38 4.482A13.93 13.93 0 0 1 1.64 3.15a4.822 4.822 0 0 0-.664 2.475c0 1.708.87 3.215 2.188 4.099a4.904 4.904 0 0 1-2.228-.616c-.054 1.98 1.388 3.83 3.444 4.244a4.935 4.935 0 0 1-2.224.085c.626 1.956 2.444 3.379 4.6 3.419a9.86 9.86 0 0 1-6.102 2.102c-.398 0-.79-.023-1.17-.067a13.91 13.91 0 0 0 7.548 2.212c9.057 0 14.009-7.496 14.009-13.986 0-.21-.004-.423-.014-.633a9.936 9.936 0 0 0 2.457-2.548l-.047-.02z",
    },
  ];

  return (
    <footer className="bg-black text-white pt-16 pb-10 px-6 sm:px-10">
      <div className="flex flex-row justify-between items-center border-b border-white/10 pb-5 mb-10 gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-sm cursor-pointer select-none">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <path d="M2 12h20M12 2c2.21 3.19 3.49 7.03 3.49 11.95S14.21 20.81 12 22" />
          </svg>
          <span>{footer.language}</span>
        </div>

        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 text-sm text-orange-500 hover:text-orange-400 transition"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
          {footer.backToTop}
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-6 lg:gap-x-16 mb-10">
        <div>
          <h3 className="text-lg font-bold mb-5 text-orange-500">{footer.brand}</h3>
          <p className="text-sm text-gray-300">{footer.subscribeDescription}</p>
          <form className="mt-6 flex flex-col sm:flex-row items-start sm:items-end gap-4">
            <input
              type="email"
              placeholder={footer.emailPlaceholder}
              className="w-full bg-transparent border-b border-white/50 text-white placeholder-gray-400 text-sm py-2 focus:outline-none focus:border-orange-500 transition"
            />
            <button
              type="submit"
              className="border border-white px-6 py-2 text-sm font-medium text-white hover:bg-orange-600 transition-colors"
            >
              {footer.subscribeButton}
            </button>
          </form>
        </div>

        {footer.linkSections.map((section) => (
          <div key={section.title}>
            <h4 className="text-lg font-semibold mb-5 pb-2 border-b border-orange-500 w-fit">{section.title}</h4>
            <ul className="space-y-2 text-sm">
              {section.links.map((link) => (
                <li key={link.label}>
                  {link.href && link.href !== "#" ? (
                    <Link to={link.href} className="text-gray-300 hover:text-white transition">
                      {link.label}
                    </Link>
                  ) : (
                    <a href="#" className="text-gray-300 hover:text-white transition">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between gap-6 text-sm">
        <div className="space-y-2">
          <p className="text-gray-400">{footer.copyright}</p>
          <div className="flex flex-wrap gap-4">
            {footer.legalLinks.map((item) => (
              <a key={item} href="#" className="text-gray-300 hover:text-white transition">
                {item}
              </a>
            ))}
          </div>
        </div>

        <div className="flex gap-4">
          {socialIcons.map((icon) => (
            <a key={icon.name} href="#" aria-label={icon.name} className="text-gray-300 hover:text-white transition">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d={icon.path} />
              </svg>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;

